"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _IconStyle = _interopRequireDefault(require("./IconStyle"));

var _AlertFill = _interopRequireDefault(require("../../icons/utils/AlertFill"));

var WarningIcon = (0, _styledComponents.default)(_AlertFill.default).withConfig({
  displayName: "WarningIcon",
  componentId: "sc-1rg7kmu-0"
})(["", " polygon{fill:", ";}path{color:", ";}"], _IconStyle.default, function (_ref) {
  var theme = _ref.theme;
  return theme.notification.color.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.notification.color.secondary;
});
var _default = WarningIcon;
exports.default = _default;
//# sourceMappingURL=WarningIcon.js.map